<template>
  <div v-if="binanceBalance" class="w-full flex-y-center gap-3">
    <div class="flex-y-center gap-1">
      <img src="/binance-logo.svg" alt="Coin" class="w-10 h-10" />
    </div>
    <div class="w-full flex-y-center justify-between gap-1">
      <div>
        <p class="text-xs text-gray-450 font-semibold">
          {{ $t("your_binance_balance") }}
        </p>
        <p
          class="text-xl font-bold leading-130"
          :key="binanceBalance"
          :class="color"
        >
          ${{ Number(binanceBalance)?.toFixed(2) }}
        </p>
      </div>
      <CRefreshButton @refresh-bots="refreshExchange" :is-refreshed="loading" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { useAuthStore } from "@/modules/Auth/stores";
import CRefreshButton from "@/components/Common/CRefreshButton.vue";

const store = useAuthStore();

let profit = null;
const color = ref("");
const loading = ref(false);

const binanceBalance = computed(
  () => store.user.unique_exchanges?.[0]?.usdt_balance,
);
const exchangeID = computed(() => store.user.unique_exchanges?.[0]?.id);

function compareValues(newValue) {
  if (profit === null) {
    profit = newValue;
    return "No previous value to compare";
  }

  let result = newValue > profit ? "green" : "red";
  profit = newValue; // Update oldValue to the new value for future comparisons
  return result;
}

watch(
  () => binanceBalance.value,
  () => {
    color.value = compareValues(binanceBalance.value);
  },
  { deep: true, immediate: true },
);

const refreshExchange = () => {
  loading.value = true;
  ApiService.post(`/bot/exchange/refresh/${exchangeID.value}/`)
    .then(async () => {
      await store.fetchUserData();
    })
    .catch((err: any) => {
      console.log(err);
    })
    .finally(() => {
      setTimeout(() => {
        loading.value = false;
      }, 300);
    });
};
</script>

<style>
.green {
  animation: grow-animation 1000ms ease-in reverse;
}
.red {
  animation: low-animation 1000ms ease-in reverse;
}
@keyframes grow-animation {
  0% {
    color: #080a15;
  }
  50% {
    color: #16cc53;
  }
  100% {
    color: #080a15;
  }
}
@keyframes low-animation {
  0% {
    color: #080a15;
  }
  50% {
    color: red;
  }
  100% {
    color: #080a15;
  }
}
</style>
<style scoped>
.spinner-loading-animation {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #6f767e 94%, #0000) top/3.8px 3.8px no-repeat,
    conic-gradient(#0000 30%, #6f767e);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - 3.8px),
    #000 0
  );
  animation: spinner-loading 1s infinite linear;
}

@keyframes spinner-loading {
  100% {
    transform: rotate(1turn);
  }
}
</style>
